import { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

import { useBle } from "../../context/BleContext";
import * as ble from "../../services/ble/";

import toast from "react-hot-toast";

export default function FormWiFi({
  updateCompletion,
}: {
  updateCompletion: (isCompleted: boolean) => void;
}) {
  // useEGW connections
  const bleApi = useBle();

  const [ssid, setSSID] = useState<string>("");

  // useState varaibles
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [ssids, setSSIDs] = useState<string[]>([]);
  const [manualInput, setManualInput] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const togglePasswordVisibility = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    updateCompletion(true);

    const payload = {
      ssid: ssid,
      psk: password,
    };

    const toastId = toast.loading("Setting wifi credentials...\nPatience is advised");
    try {
      setIsSubmitting(true);
      const response = await bleApi.fetch(ble.API_WIFI, ble.Method.POST, payload);
      console.log("WiFi credentials: ", response);
      if (response.status === "EGWTP/1.1 200 OK" && response.payload.status === "ok") {
        toast.remove(toastId);
        toast.success("Wifi credentials set");
      } else {
        toast.remove(toastId);
        if (response.status !== "EGWTP/1.1 200 OK") {
          toast.error("Setting wifi credentials failed, status: " + response.status);
        } else {
          toast.error("Setting wifi credentials failed, status: " + response.payload.status);
        }
      }
      setIsSubmitting(false);
    } catch (error) {
      console.log(error);
      toast.remove(toastId);
      toast.error("Setting wifi credentials failed");
      setIsSubmitting(false);
    }
  };

  // ask for ssids
  useEffect(() => {
    async function getSSIDs() {
      try {
        const response = await bleApi.fetch(ble.API_WIFI, ble.Method.GET, {});
        console.log("WiFi credentials: ", response);
        if (response.payload.ssids) {
          setSSIDs(response.payload.ssids);
        }


      } catch (error) {
        console.log(error);
      }
    }
    getSSIDs();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  // useEffect(() => {
  //   console.log('useEffect called');
  //   async function getNetworkStuff() {
  //     try {
  //       const response = await bleApi.fetch('/api/network', ble.Method.GET, {});
  //       console.log("network blob: ", response);

  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  //   getNetworkStuff();
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="space-y-4">
        <div className="flex flex-col space-y-2">
          <label htmlFor="network" className="text-sm font-medium text-gray-300">Network SSID:</label>
          <div className="relative">
            <select
              className="w-full bg-[#1D1D1D] rounded-[8px] border border-[#292929] pl-4 pr-12 py-2 text-sm text-gray-200 appearance-none"
              id="network"
              value={ssid}
              onChange={(e) => setSSID(e.target.value)}
              disabled={isSubmitting}
            >
              <option value="">Select a network...</option>
              {ssids.map((ssid: string, index: number) => (
                <option key={index} value={ssid}>
                  {ssid}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
              <svg className="fill-current h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </div>
          </div>
        </div>
        <div className="flex flex-col space-y-2">
          <div className="flex justify-between">
            <label htmlFor="networkManual" className="text-sm font-medium text-gray-300">Manual input SSID:</label>
            <input
              className="h-4 w-4 rounded-lg"
              type="checkbox"
              name="networkManual"
              id="networkManual"
              checked={manualInput}
              onChange={(e) => setManualInput(e.target.checked)}
              disabled={isSubmitting}
            />
          </div>
          {manualInput && (
            <input
              type="text"
              placeholder="Enter SSID manually"
              className="mt-2 bg-[#1D1D1D] rounded-[8px] border border-[#292929] px-4 py-2 text-sm text-gray-200"
              onChange={(e) => setSSID(e.target.value)}
              disabled={isSubmitting}
            />
          )}
        </div>
        <div className="flex flex-col space-y-2">
          <label htmlFor="password" className="text-sm font-medium text-gray-300">Password</label>
          <div className="relative">
            <input
              placeholder="Password"
              className="w-full bg-[#1D1D1D] rounded-[8px] border border-[#292929] px-4 py-2 pr-12 text-sm text-gray-200"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="off"
              disabled={isSubmitting}
            />
            <button
              className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-gray-300"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? (
                <FaEyeSlash className="h-4 w-4" />
              ) : (
                <FaEye className="h-4 w-4" />
              )}
            </button>
          </div>
          <button 
            className="px-4 py-2 bg-[#00FF84] hover:bg-green-500 text-black font-medium rounded-[8px] transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-4" 
            disabled={isSubmitting}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
}
